import { createSelector } from 'reselect'
import { StoreState } from '..'

export const getLocationDetail = createSelector(
  ({ _locationDetail }: StoreState) => _locationDetail.data,
  (_locationDetail) => _locationDetail.result
)

export const getLocationPopularAreas = createSelector(
  ({ locationPopularAreas }: StoreState) => locationPopularAreas.data,
  (locationPopularAreas) => locationPopularAreas.result
)

//おすすめ預かり場所
export const getLocationRecommendedSpaces = createSelector(
  ({ locationRecommendedSpaces }: StoreState) => locationRecommendedSpaces.data,
  (locationRecommendedSpacesState) => locationRecommendedSpacesState.result
)

// コインロッカー
export const getLocationCoinLockers = createSelector(
  ({ locationCoinLockers }: StoreState) => locationCoinLockers.data,
  (locationCoinLockersState) => locationCoinLockersState.result
)

// 駅
export const getLocationStations = createSelector(
  ({ locationStations }: StoreState) => locationStations.data,
  (locationStationsState) => locationStationsState.result
)

// 施設
export const getLocationFacilities = createSelector(
  ({ locationFacilities }: StoreState) => locationFacilities.data,
  (locationFacilitiesState) => locationFacilitiesState.result
)

// 旧コインロッカー
export const getLocationOldCoinLockers = createSelector(
  ({ locationOldCoinLockers }: StoreState) => locationOldCoinLockers,
  (locationOldCoinLockersState) => locationOldCoinLockersState.data
)
